export default __webpack_public_path__ + "static/media/danny_koifman.6e8a7cd3.jpeg";